<template lang="pug">
  div
    .promo__list-item__loader(v-for="index in length" :key="index")
      .promo__list-item__loader__title
      .promo__list-item__loader__subtitle
</template>
<script>
export default {
  name: 'PromoListItemLoader',
  props: {
    length: {
      type: Number,
      default: 1,
    },
  },
};
</script>
<style scoped>
.promo__list-item__loader {
  padding: 16px 0px;
  border-bottom: 1px solid rgba(0,0,0,.06);
}
.promo__list-item__loader__title {
  background: #F4F4F4;
  width: 100px;
  height: 16px;
  margin-bottom: 4px;
  border-radius: 20px;
}
.promo__list-item__loader__subtitle {
  background: #F4F4F4;
  width: 232px;
  height: 16px;
  border-radius: 20px;
}
</style>
